import { PATHS } from "@/shared/publicPaths";

/**
 * Full document navigation for Vike SSR routes.
 * Use instead of React Router <Link> / navigate() so `onBeforeRender` runs
 * and pre-rendered props (e.g. initialCategories on /servicios) are available.
 */
export function navigateFullPage(path: string): void {
  if (typeof window === "undefined") return;
  window.location.assign(path);
}

/** Plain <a href> target for the services listing (SSR). */
const SERVICES_LIST_PATH = PATHS.services;

export function isServicesListPath(path: string): boolean {
  return path === SERVICES_LIST_PATH || path.startsWith(`${SERVICES_LIST_PATH}?`);
}
